import api from "@/util/api"

const MAX_API_ATTEMPTS = 3;

export const state = {
  newsletterState: false,
  userLoggedIn: false,
  userDetails: {},
  deliveryDetails: {}
}

export const mutations = {
  SET_NEWSLETTER_STATE(state, value) {
    state.newsletterState = value;
  },
  SET_USER_LOGGED_IN(state, status) {
    state.userLoggedIn = status
  },
  SET_USER_DETAILS(state, details) {
    state.userDetails = details
  },
  SET_DELIVERY_INFORMATION(state, deliveryInfo) {
    state.deliveryDetails = deliveryInfo;
  },
}

export const actions = {
  updateUserLoggedIn({ commit }, value) {
    commit('SET_USER_LOGGED_IN', value)
  },
  updateDeliveryInformation({ commit }, info) {
    commit('SET_DELIVERY_INFORMATION', info)
  },
  updateNewsletterState({ commit }, value) {
    commit('SET_NEWSLETTER_STATE', value)
  },
  async retrieveUserDetails({ commit }) {
    let attempts = 0;

    while (attempts < MAX_API_ATTEMPTS) {
      attempts++;

      try {
        let response = await api.getLoggedUser();

        if (response.status == 200) {
          attempts = MAX_API_ATTEMPTS
          commit('SET_USER_LOGGED_IN', true)
          commit('SET_USER_DETAILS', response.data)
        } else {
          commit('SET_USER_LOGGED_IN', false)
          commit('SET_USER_DETAILS', {})
          attempts = MAX_API_ATTEMPTS
        }
      } catch (e) {
        commit('SET_USER_LOGGED_IN', false)
        commit('SET_USER_DETAILS', {})
        attempts = MAX_API_ATTEMPTS
      }
    }
  },
  // Each module reacts to an action event that is dispatched
  // i.e. destroyCartInstance also exists within cart.js https://vuex.vuejs.org/guide/modules.html#namespacing
  destroyCartInstance({ commit }) {
    commit('SET_NEWSLETTER_STATE', false)
  }
}

export const getters = {
  isLoggedIn: state => {
    return state.userLoggedIn
  },
}
